import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  textForInvestors: {
    id: 'component.Layout.Header.span.forInvestors',
    defaultMessage: 'Relacje Inwestorskie'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Header/Header.intl.js